import axiosInstance from "./axiosInstance";

export interface CompanyInfo {
    logo: string;
    logo_footer: string;
    company_name: string;
    company_name_ru: string;
    work_direction: string;

    support_phone_number: string;
    support_email: string;
    address: string;

    send_form_title: string;
    send_form_subtitle: string;
    work_segment: string;
    send_button_politic: string;

    TIN: bigint;
    OGRNIP: bigint;
    license: string;
    person_data_politic: string;

    licence_file: string | null;
    licence_url: string | null
}

export interface FormData {
    full_name: string,
    phone_number: string,
    email: string,
    comment: string,
    send_date: string,
}

export interface Card {
    text: string;
    image: string;
}

export interface WorkDirection {
    title: string;
    description?: string;
    manual: string | null;
    about: string | null;
    image: string;
}

export interface Command {
    image: string;
    full_name: string;
    profession: string;
}

type PaginationModel<T> = {
    count: number
    next: string | null
    previous: string | null
    results: Array<T>
}

export type MainActivityCardType = {
    id: number
    text: string
    image: string
    created_at: string
    updated_at: string
}

export type MainActivityType = PaginationModel<MainActivityCardType>

export type ProjectCardType = {
    id: number
    title: string
    description?: string
    image?: string
    caption?: string
    created_at: string
    updated_at: string
}

export type ProjectsType = PaginationModel<ProjectCardType>

export type LicenseCardType = {
    id: number
    text: string
    image?: string
    created_at: string
    updated_at: string
}

export type LicensesType = PaginationModel<LicenseCardType>


export const getCompanyInfo = async (id: number): Promise<CompanyInfo> => {
    try {
        const response = await axiosInstance.get(`company_info/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const sendFormData = async (formData: FormData) => {
    try {
        const response = await axiosInstance.post("send_form/", formData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getCompanyInfoCard = async (): Promise<Card[]> => {
    try {
        const response = await axiosInstance.get('company_info_card/');
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getWorkDirectionCard = async (): Promise<WorkDirection[]> => {
    try {
        const response = await axiosInstance.get('work_direction/');
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getMainActivity = async (): Promise<MainActivityType> => {
    try {
        const response = await axiosInstance.get('activities/');
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getProjects = async (): Promise<ProjectsType> => {
    try {
        const response = await axiosInstance.get('projects/');
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getLicenses = async (): Promise<LicensesType> => {
    try {
        const response = await axiosInstance.get('licenses/');
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getCommandCard = async (): Promise<Command[]> => {
    try {
        const response = await axiosInstance.get('command/');
        return response.data;
    } catch (error) {
        throw error;
    }
};
